<template>
    <div>
        <div class="fw-bold">
            {{ designName }}
        </div>
        <div v-if="enable">
            <div class="fw-bold">
                {{ enableMessageHeader }}
            </div>
            <br />
            <div>
                {{ enableMessageBody }}
            </div>
            <pc-alert v-bind="alertBinder">
                {{ enableWarningMessage }}
            </pc-alert>
        </div>
        <div v-else>
            <div class="fw-bold">
                {{ disableMessageHeader }}
            </div>
            <br />
            <div>
                {{ disableMessageBody }}
            </div>
        </div>
    </div>
</template>

<script>
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/enableIncentiveDesignDialog.i18n";
    import { ALERT_SEVERITY } from "Util/alerts";

    export default {
        props: {
            designName: { type: String, required: true },
            enable: { type: Boolean, required: true }
        },
        computed: {
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            ),
            alertBinder() {
                return {
                    shown: true,
                    severity: ALERT_SEVERITY.warning,
                    class: { "mb-0": true, "mt-3": true }
                };
            }
        }
    };
</script>
